var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-group" },
    [
      _vm.prepend && _vm.icon
        ? _c("div", { staticClass: "input-group-prepend" }, [
            _c("span", { staticClass: "input-group-text" }, [
              _c("i", { class: _vm.icon })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.append
        ? _c(
            "div",
            { staticClass: "input-group-append" },
            [_vm._t("append")],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }